/**
 * The campaign builder header, its save-status chip (PREC-4151), its stale-save conflict modal
 * (PREC-4026) and the same-company stop setting of the create/edit campaign modals (PREC-4241).
 */
export const enCampaignBuilder = {
	validInfo: "Campaign is valid — you can now start assigning prospects.",
	goToLeadList: "Go to lead list",
	saving: "Saving…",
	saved: "All changes saved",
	savedAt: "Saved {{time}}",
	saveUnsaved: "Unsaved changes…",
	saveFailed: "Not saved",
	saveRetry: "Retry",
	saveStructureLocked:
		"This campaign has sent its first steps; its steps and conditions can no longer change.",
	leaveTitle: "This campaign has unsaved changes",
	leaveBody:
		"Your last edit has not been saved yet. Leaving now would discard it — the builder saves about a second after you stop typing.",
	leaveSave: "Save and leave",
	leaveDiscard: "Leave without saving",
	conflictTitle: "This campaign was changed elsewhere",
	conflictBody:
		"Another tab or a teammate saved a newer version of this campaign while you were editing it. Choose which version to keep.",
	conflictHint:
		"Keeping your version overwrites the newer one. Loading the newer version discards your unsaved edits here.",
	conflictKeepMine: "Keep my version",
	conflictTakeTheirs: "Load the newer version",
	// Permanent since PREC-3895 (SameCompanyStopService): change this wording when that behaviour changes.
	sameCompanyStopLabel: "Stop Contacting Colleagues After a Reply",
	sameCompanyStopDescription:
		"When someone at a company replies to this campaign, stop this campaign for their colleagues on this list. Their remaining steps are cancelled for good. Out-of-office notices and bounces don't count.",
	// PREC-3897: what a step's position in the sequence means for the leads that reach it.
	stepPath: {
		noLinkedin: "Leads on this path have no LinkedIn profile, so a LinkedIn step can't reach them.",
		notAccepted:
			"Leads on this path haven't accepted your invitation, so a LinkedIn message can't reach them.",
		noEmail: "Leads on this path have no email address, so an email can't reach them.",
		firstMessageNeedsConnection:
			"As the first step, a LinkedIn message only reaches leads you're already connected with and fails for everyone else. Start with a LinkedIn invitation to reach them.",
		inmailNeedsSender:
			"InMails are only sent by senders with LinkedIn Sales Navigator or Premium, and none of this campaign's LinkedIn senders has one yet. You can keep the step and add such a sender later.",
		inviteWithAcceptedCheck: "Then check whether the invitation was accepted",
	},
	// PREC-4258: the one campaign delete (trash icon and gear menu). CampaignDeletionService decides
	// what it does to the leads: change this wording when that behaviour changes.
	deleteCampaignTitle: "Delete campaign",
	deleteCampaignLeads_one:
		"1 lead is assigned to “{{name}}”. Deleting the campaign cancels its pending steps.",
	deleteCampaignLeads_other:
		"{{count}} leads are assigned to “{{name}}”. Deleting the campaign cancels their pending steps.",
	deleteCampaignOutcome:
		"Leads in the sequence that no message has reached yet go back to New. Leads a message has already reached are ended. Leads that already finished keep their status. Messages you scheduled by hand in the Outbox still go out.",
	deleteCampaignNoLeads:
		"No leads are assigned to “{{name}}”. Deleting it removes the campaign and its steps.",
	deleteCampaignCounting: "Counting the leads assigned to this campaign…",
	deleteCampaignCountFailed:
		"The leads assigned to this campaign could not be counted, so it cannot be deleted right now. Try again in a moment.",
	deleteCampaignConfirm: "Delete campaign",
	deleteCampaignDone:
		"Campaign deleted: {{toNew}} back to New, {{ended}} ended, {{cancelled}} pending steps cancelled.",
	deleteCampaignFailed: "The campaign could not be deleted.",
	deleteCampaignBusy:
		"Leads are being added to this list's campaigns right now, so the campaign cannot be deleted at this moment. Try again in a minute.",
	// PREC-4258: the open campaign was deleted elsewhere (another tab, a teammate, MCP).
	campaignDeletedElsewhere:
		"This campaign was deleted, so the builder moved on. Edits to it can no longer be saved.",
	// PREC-4426: the "Send LinkedIn Invite" step's switch. Read at send time by `runCampaignStep` →
	// `stopLeadAlreadyConnected` (api schedule/utils); change this wording when that behaviour changes.
	inviteStopLabel: "Stop the campaign for leads who are already connected",
	inviteStopOnDescription:
		"If the sender is already connected to the lead on LinkedIn, no invite is sent, the campaign ends for that lead, and the lead shows in Outbox → Error.",
	inviteStopOffDescription:
		"Off: for a lead who is already connected, the invite is skipped and the campaign continues with the next step.",
	inviteStopTooltip: "Off: the invite is skipped and the campaign continues with the next step.",
};
